import React from "react";

const Group2Card = (props) => {
  // main name
  // metric image
  // investment amount name --  value
  // # of assets name -- value
  // # of tenants name -- value
  // available capacity -- value
  // weighted average remaining -- value
  // weighted average annual -- value
  const imgPathUrl = process.env.REACT_APP_PUBLICRATES_URL;

  // function that takes the api text, separates it, and italicizes the text in parentheses
  const LeaseTermText = ({ apiText }) => {
    // Regular expression to find text inside parentheses, including the parentheses
    const regex = /\(.*?\)/;

    // Use match to find the part in parentheses (including the parentheses)
    const italicText = apiText.match(regex);

    // Get the text before and after the parentheses
    const parts = apiText.split(regex);

    return (
      <p>
        {parts[0]}
        {italicText && <span className="italic text-sm">{italicText[0]}</span>}
        {parts[1]}
      </p>
    );
  };
  return props.dType === "desktop" ? (
    <div>
      <div className="bg-white shadow-lg relative h-auto min-h-full">
        <div className="g2-card-top bg-hmcChartHeaderBg flex items-center justify-center">
          <h2 className="text-center p-7 text-white text-2xl">
            {props.title}
            <sup style={{ fontSize: "10px" }}>{props.titleSup}</sup>
          </h2>
        </div>
        <div className="g2-card-bottom">
          <table className="table-noStyle w-full">
            <tr>
              <td width={"65%"}>
                {props.i1Name}
                <sup style={{ fontSize: "10px" }}>{props.i1Sup}</sup>
              </td>
              <td className="t-right">{props.i1Value}</td>
            </tr>
            <tr>
              <td>
                {props.i2Name}
                <sup style={{ fontSize: "10px" }}>{props.i2Sup}</sup>
              </td>
              <td className="t-right">{props.i2Value}</td>
            </tr>
            <tr>
              <td>
                {props.i3Name}
                <sup style={{ fontSize: "10px" }}>{props.i3Sup}</sup>
              </td>
              <td className="t-right">{props.i3Value}</td>
            </tr>
            <tr>
              <td>
                {props.i4Name}
                <sup style={{ fontSize: "10px" }}>{props.i4Sup}</sup>
              </td>
              <td className="t-right">{props.i4Value}</td>
            </tr>
            <tr>
              <td>
                <LeaseTermText apiText={props.i5Name} />
                <sup style={{ fontSize: "10px" }}>{props.i5Sup}</sup>
              </td>
              <td className="t-right">{props.i5Value}</td>
            </tr>
            <tr>
              <td>
                {props.i6Name}
                <sup style={{ fontSize: "10px" }}>{props.i6Sup}</sup>
              </td>
              <td className="t-right">{props.i6Value}</td>
            </tr>
          </table>
        </div>
      </div>
      <div className="w-full h-2 bg-hmcGold mt-[6px]"></div>
    </div>
  ) : (
    <div className="mx-3">
      <div className="bg-white shadow-lg relative h-auto min-h-full">
        <div className="g2-card-top bg-hmcChartHeaderBg flex items-center justify-center">
          <h2 className="text-center py-7 text-white text-xl">
            {props.title}
            <sup style={{ fontSize: "10px" }}>{props.titleSup}</sup>
          </h2>
        </div>
        <div className="g2-card-bottom h-[425px]">
          <table className="table-noStyle w-full">
            <tr>
              <td width={"65%"}>
                {props.i1Name}
                <sup style={{ fontSize: "10px" }}>{props.i1Sup}</sup>
              </td>
              <td className="t-right">{props.i1Value}</td>
            </tr>
            <tr>
              <td>
                {props.i2Name}
                <sup style={{ fontSize: "10px" }}>{props.i2Sup}</sup>
              </td>
              <td className="t-right">{props.i2Value}</td>
            </tr>
            <tr>
              <td>
                {props.i3Name}
                <sup style={{ fontSize: "10px" }}>{props.i3Sup}</sup>
              </td>
              <td className="t-right">{props.i3Value}</td>
            </tr>
            <tr>
              <td>
                {props.i4Name}
                <sup style={{ fontSize: "10px" }}>{props.i4Sup}</sup>
              </td>
              <td className="t-right">{props.i4Value}</td>
            </tr>
            <tr>
              <td>
                <LeaseTermText apiText={props.i5Name} />
                <sup style={{ fontSize: "10px" }}>{props.i5Sup}</sup>
              </td>
              <td className="t-right">{props.i5Value}</td>
            </tr>
            <tr>
              <td>
                {props.i6Name}
                <sup style={{ fontSize: "10px" }}>{props.i6Sup}</sup>
              </td>
              <td className="t-right">{props.i6Value}</td>
            </tr>
          </table>
        </div>
      </div>
      <div className="w-full h-2 bg-hmcGold mt-[6px]"></div>
    </div>
  );
};

export default Group2Card;
